import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { src: String };

  connect() {
    if (this.element.src) return;
    if (!("IntersectionObserver" in window)) {
      this.#load();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.#load();
      },
      { rootMargin: "200px" },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  #load() {
    this.element.src = this.srcValue;
    this.observer?.disconnect();
  }
}
